/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 5a03ec7cd70d2454183701819954bb12 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StandaloneCarQuickEstimatesQueryVariables = {};
export type StandaloneCarQuickEstimatesQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"CarQuickEstimatesForm_viewer">;
    };
};
export type StandaloneCarQuickEstimatesQuery = {
    readonly response: StandaloneCarQuickEstimatesQueryResponse;
    readonly variables: StandaloneCarQuickEstimatesQueryVariables;
};



/*
query StandaloneCarQuickEstimatesQuery {
  viewer {
    ...CarQuickEstimatesForm_viewer
  }
}

fragment CarQuickEstimatesForm_viewer on Viewer {
  currentUser {
    fullName
    id
  }
}
*/

const node: ConcreteRequest = {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "StandaloneCarQuickEstimatesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CarQuickEstimatesForm_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "StandaloneCarQuickEstimatesQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "StandaloneCarQuickEstimatesQuery",
    "id": null,
    "text": "query StandaloneCarQuickEstimatesQuery {\n  viewer {\n    ...CarQuickEstimatesForm_viewer\n  }\n}\n\nfragment CarQuickEstimatesForm_viewer on Viewer {\n  currentUser {\n    fullName\n    id\n  }\n}\n",
    "metadata": {}
  }
};
(node as any).hash = '0fcf6b0638d3d965e21fb32b9c7a2f87';
export default node;
